import { XPSEntry } from './../constants/actionType'

const initialState = {
    retrieveSmartCart: null,
    resumeSavedMon: "",
    lqResponse: {},
    incorrectMonErr: false,
    showEmailMTNSec: false,
    resumeMonErr: false,
    sendCartNum: "",
    sendSmsorEmailErr: false,
    sendSmsorEmailErrAttempts: 0,
    sendSmsorEmailAttemptsError: false,
    isMemoryClearedForNewVisit: false,
    isMemoryClearedForChatVisit:false,
    xpsCaptchaState : '',
    xpsShowCaptchaFromVisitId : false,
    xpsShowLBOFromVisitId : false,
    showLoaderOnSCPageStart: ""
}

function xpsEntry(state = initialState, action) {
    switch (action.type) {
        case XPSEntry.retrieveSmartCart:
            return Object.assign({}, state, {
                retrieveSmartCart: action.value
            })
        case XPSEntry.resumeMonErr:
            return Object.assign({}, state, {
                resumeMonErr: action.value
            })
        case XPSEntry.resumeSavedMon:
            return Object.assign({}, state, {
                resumeSavedMon: action.value
            })
        case XPSEntry.updateLQFromXPSEntry:
            return Object.assign({}, state, {
                lqResponse: action.value
            })
        case XPSEntry.incorrectMonErr:
            return Object.assign({}, state, {
                incorrectMonErr: action.value
            })

        case XPSEntry.showMTNEmailSec:
            return Object.assign({}, state, {
                showEmailMTNSec: action.value
            })
        case XPSEntry.sendCartNum:
            return Object.assign({}, state, {
                sendCartNum: action.value
            })
        case XPSEntry.sendSmsorEmailErr:
            return Object.assign({}, state, {
                sendSmsorEmailErr: action.value
            })
        case XPSEntry.sendSmsorEmailErrAttempts:
            return Object.assign({}, state, {
                sendSmsorEmailErrAttempts: action.value
            })
        case XPSEntry.sendSmsorEmailAttemptsError:
            return Object.assign({}, state, {
                sendSmsorEmailAttemptsError: action.value
            })
        case XPSEntry.isMemoryClearedForNewVisit:
            return Object.assign({}, state, {
                isMemoryClearedForNewVisit: action.value
            })
        case XPSEntry.isMemoryClearedForChatVisit:
            return Object.assign({}, state, {
                isMemoryClearedForChatVisit: action.value
            })
        case XPSEntry.xpsCaptchaChanged: {
            return (Object.assign({}, state, {
                xpsCaptchaState: action.value
            }))
        }
        case XPSEntry.xpsShowCaptchaLBOFromVisitId: {
            return (Object.assign({}, state, {
                xpsShowCaptchaFromVisitId: action.showCaptchaFromVisitId,
                xpsShowLBOFromVisitId: action.showLBOFromVisitId
            }))
        } 
        case XPSEntry.showLoaderOnSCPageStart: {
            return (Object.assign({}, state, {
                showLoaderOnSCPageStart: action.value
            }))
        }
        default:
            return state
    }
}

export default xpsEntry